module.exports = __webpack_public_path__ + "static/media/plus_icon.b6beaa25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/plus_icon.svg
// module id = 844
// module chunks = 0